import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import InvestOptions from "./components/InvestOptions";
import TopPicks from "./components/TopPicks";
import WhyInvest from "./components/WhyInvest";
import Returns from "./components/Returns";
import RevenueDrivers from "./components/RevenueDrivers";
import Features from "./components/Features";
import InvestmentModel from "./components/InvestmentModel";
import RevenueModels from "./components/RevenueModels";
import IdealFor from "./components/IdealFor";
import UspCta from "./components/UspCta";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CmsPage from "@/components/cms/CmsPage";

export default function Home() {
  return (
    <main className="w-full">
      <Navbar />
      <CmsPage slug="home" path="/" fallbackSeo={{ title: "NOMADLIVINGS | Premium A-Frame Villa Investments", description: "Invest in premium modular A-frame villas engineered for hospitality, strong rental returns and unforgettable stays across India." }}>
        <Hero />
        <InvestOptions />
        <TopPicks />
        <WhyInvest />
        <Returns />
        <RevenueDrivers />
        <Features />
        <InvestmentModel />
        <RevenueModels />
        <IdealFor />
        <UspCta />
        <Contact />
      </CmsPage>
      <Footer />
    </main>
  );
}